/**
 * AgentMemoryApiClient -- HTTP client for /api/v1/agent-memory.
 * Acceso a la memoria persistente de Argemiro (conv.chat_memory en agent_hub).
 * Read-only: lista sessions, mensajes, búsqueda, estadísticas.
 *
 * Mission: ARES-AGENT-QUALITY-001 (F1)
 * @module infrastructure/api/AgentMemoryApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/agent-memory';

export const AgentMemoryApiClient = {
  /**
   * Lista sessions con métricas (conteo mensajes, primer/último timestamp).
   * @param {number} limit - max sessions a devolver (default 50)
   * @param {number} offset - paginación
   */
  async listSessions(limit = 50, offset = 0) {
    return ApiBase.get(`${BASE}/sessions?limit=${limit}&offset=${offset}`);
  },

  /**
   * Mensajes de una session específica.
   * @param {string} sessionId
   * @param {number} limit - default 100
   */
  async getMessages(sessionId, limit = 100) {
    const encoded = encodeURIComponent(sessionId);
    return ApiBase.get(`${BASE}/messages/${encoded}?limit=${limit}`);
  },

  /**
   * Busca mensajes por contenido.
   * @param {string} query - texto a buscar (ILIKE %q%)
   * @param {number} limit
   */
  async search(query, limit = 50) {
    const encoded = encodeURIComponent(query);
    return ApiBase.get(`${BASE}/search?q=${encoded}&limit=${limit}`);
  },

  /**
   * Resumen global de la memoria del agente.
   */
  async getStats() {
    return ApiBase.get(`${BASE}/stats`);
  },

  // F2+F3: Facts compilados
  async getFacts(externalId, factType) {
    const params = [];
    if (externalId) params.push(`externalId=${encodeURIComponent(externalId)}`);
    if (factType) params.push(`factType=${encodeURIComponent(factType)}`);
    const qs = params.length ? '?' + params.join('&') : '';
    return ApiBase.get(`${BASE}/facts${qs}`);
  },

  async getFactsSummary() {
    return ApiBase.get(`${BASE}/facts/summary`);
  }
};
